import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmIconModule } from '@metromarkets/components';

import { MediaControlModule } from '~shared/modules/media-control/media-control.module';

import { BaseWireframeComponent } from './components/base-wireframe/base-wireframe.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { BackLinkComponent } from './components/back-link/back-link.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { PageContentComponent } from './components/page-content/page-content.component';

const exportedComponents = [
  BaseWireframeComponent,
  PageTitleComponent,
  BackLinkComponent,
  TopbarComponent,
  SidebarComponent,
  PageContentComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    QaLocatorsModule,
    MmIconModule,
    MediaControlModule,
  ],
  declarations: [
    ...exportedComponents,
  ],
  exports: [
    ...exportedComponents,
  ],
})
export class BasePageModule {}
